import React from 'react';
import PropTypes from 'prop-types';
import CapabilityCircle from './CapabilityCircle';

const Capability = ({ label, checked }) => (
  <div className="flex items-center justify-between mb-2">
    <label className="my-0 form-label">{label}</label>
    <CapabilityCircle checked={checked} />
  </div>
);

Capability.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default Capability;
